import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 18,
	viewBox: "0 0 20 20",
	fill: "#ea3943",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Path_7416",
		"data-name": "Path 7416",
		d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,15a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0v4A1,1,0,0,1,12,17Zm1-8H11V7h2Z",
		transform: "translate(-2 -2)"
	})
});
export { SvgWarningIcon as ReactComponent };
